<app-topbar></app-topbar>
<app-sidebar></app-sidebar>

<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">Profile</h3>
          <p class="page-head__sub">Profile Info</p>
        </div>
      </div>
    </div>

    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <form [formGroup]="form" (ngSubmit)="updateAdmin()">
            <div class="row card-header">
              <div class="col-md-2"></div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-5 heading">Full Name</div>
                  @if (edit.isEdit === false) {
                    <div class="col-md-7 detail">
                      {{ data?.name }}
                    </div>
                  }
                  @if (edit.isEdit === true) {
                    <div class="col-md-7 detail">
                      <input
                        type="text"
                        formControlName="name"
                        class="form-control round"
                        name="name"
                        />
                      @if (name.touched && name.invalid) {
                        <div
                          class="alert alert-danger error"
                          >
                          @if (name.errors.required) {
                            <div>
                              Full Name is required
                            </div>
                          }
                          @if (name.errors.minlength) {
                            <div>
                              Full Name should be minimum of 3 characters
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }

                  @if (data?.permission === 'admin') {
                    <div
                      class="col-md-5 heading"
                      >
                      IMTO Name
                    </div>
                  }
                  @if (data?.permission === 'admin') {
                    <div
                      class="col-md-7 details"
                      >
                      <h4>
                        <a [routerLink]="['/agent', $safeNavigationMigration(data?.agent.slug)]">{{
                          data?.agent.name
                        }}</a>
                      </h4>
                    </div>
                  }

                  @if (data?.permission === 'super_admin') {
                    <div
                      class="col-md-5 heading"
                      >
                      Administrator Level
                    </div>
                  }
                  @if (data?.permission === 'super_admin') {
                    <div
                      class="col-md-7 details"
                      >
                      <h4>
                        <span
                          class="btn btn-outline-info round"
                          style="border-color: #f1c40f !important"
                          >SUPERADMIN</span
                          >
                        </h4>
                      </div>
                    }

                    <div class="col-md-5 heading">Telephone</div>
                    @if (edit.isEdit === false) {
                      <div class="col-md-7 details">
                        {{ data?.phone_number || "Not Specified" }}
                      </div>
                    }
                    @if (edit.isEdit === true) {
                      <div class="col-md-7 detail">
                        <input
                          type="text"
                          formControlName="phone_number"
                          class="form-control round"
                          name="phone_number"
                          />
                        @if (phone_number.invalid && phone_number.touched) {
                          <div
                            class="alert alert-danger error"
                            >
                            @if (phone_number.errors.required) {
                              <div>
                                Phone number is required
                              </div>
                            }
                            @if (phone_number.errors.minlength) {
                              <div>
                                Please complete the numbers
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    <div class="col-md-5 heading">Password</div>
                    @if (edit.isEdit === false) {
                      <div class="col-md-7 detail">
                        ****************
                      </div>
                    }
                    @if (edit.isEdit === true) {
                      <div class="col-md-7 detail">
                        <input
                          type="password"
                          formControlName="password"
                          class="form-control round"
                          name="password"
                          />
                        @if (password.invalid && password.touched) {
                          <div
                            class="alert alert-danger error"
                            >
                            @if (password.errors.required) {
                              <div>
                                Password is required
                              </div>
                            }
                            @if (password.errors.minlength) {
                              <div>
                                Password can be less than 6 characters
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    <div class="col-md-5 heading">Email</div>
                    <div class="col-md-7 details">{{ data?.email }}</div>

                    <div class="col-md-5 heading">Address</div>
                    @if (edit.isEdit === false) {
                      <div class="col-md-7 detail">
                        {{ data?.address || "Not Specified" }}
                      </div>
                    }
                    @if (edit.isEdit === true) {
                      <div class="col-md-7 detail">
                        <input
                          type="text"
                          formControlName="address"
                          class="form-control round"
                          name="address"
                          />
                        @if (address.invalid && address.touched) {
                          <div
                            class="alert alert-danger error"
                            >
                            @if (address.errors.required) {
                              <div>
                                Address is required
                              </div>
                            }
                            @if (address.errors.minlength) {
                              <div>
                                Please complete the address
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    <div class="col-md-5 heading">Country</div>
                    @if (edit.isEdit === false) {
                      <div class="col-md-7 details">
                        {{ data?.country?.name || "Not Specified" }}
                      </div>
                    }
                    @if (edit.isEdit === true) {
                      <div class="col-md-7 detail">
                        <select
                          class="form-control round"
                          formControlName="country_id"
                          name="country_id"
                          >
                          <option value="{{ data?.city?.id }}" [selected]="true">
                            {{ data?.country?.name || "Select Country" }}
                          </option>
                        </select>
                      </div>
                    }

                    <div class="col-md-5 heading">State/Province</div>
                    @if (edit.isEdit === false) {
                      <div class="col-md-7 details">
                        {{ data?.city?.name || "Not Specified" }}
                      </div>
                    }
                    @if (edit.isEdit === true) {
                      <div class="col-md-7 detail">
                        <select
                          class="form-control round"
                          formControlName="state_id"
                          name="state_id"
                          >
                          <option value="{{ data?.city?.id }}" [selected]="true">
                            {{ data?.city?.name || "Select State" }}
                          </option>
                        </select>
                      </div>
                    }
                  </div>
                </div>

                <div class="centralise">
                  @if (edit.isEdit === false) {
                    <button
                      class="btn btn-success btn-round pl-30 pr-30"
                      (click)="onClick()"
                      >
                      EDIT PROFILE
                    </button>
                  }
                  @if (edit.isEdit === true) {
                    <button
                      class="btn btn-success btn-round pl-30 pr-30"
                      type="submit"
                      [disabled]="form.invalid || clicked === true"
                      >
                      UPDATE PROFILE</button
                      >
                      }@if (clicked === true) {
                      <i
                        class="icons icon-loading"
                        style="line-height: 10px"
                      ></i>
                    }
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-bottombar></app-bottombar>
